import { useCallback, useEffect, useState } from 'react';

export function useAuth() {
    const [token, setToken] = useState(null);
    const [userId, setUserId] = useState(null);
    const [loginUser, setLoginUser] = useState('');

    const login = useCallback((jwtToken, id, loginUser) => {
        setUserId(id);
        setToken(jwtToken);
        setLoginUser(loginUser);

        const data = JSON.parse(localStorage.getItem('Bari Lur'));

        if (!data) {
            localStorage.setItem('Bari Lur', JSON.stringify({
                userId: id,
                token: jwtToken,
                login: loginUser,
                isLogin: true,
            }))
        }
    }, [])

    const logout = () => {
        setUserId(null);
        setToken(null);
        setLoginUser(null);
        localStorage.removeItem('Bari Lur');
    }

    useEffect(() => {
        const data = JSON.parse(localStorage.getItem('Bari Lur'));

        if (data && data.token) {
            login(data.token, data.userId, data.login);
        }
    }, [login])

    return { userId, loginUser, token, login, logout };
}